function openWishlist() {
  updateX();
  document.querySelector('.st-wishlist-details-button').click();
}
function updateX() {
  $(".st-wishlist-details_title .st-close-button").html('<svg width="24" height="24" class="st-delete-icon"> <use xlink:href="#st_close_icon"></use> </svg>');
}
document.addEventListener("DOMContentLoaded", (event) => {
  $(document).ready(function () {
    $(".st-wishlist-details_empty").append('<div style=" position: absolute; bottom: 0; left: 0; padding: 10px; width: 100%; "> <a href="/collections/popular" class="button w-100 button-secondary">Continue Shopping</a> </div>')
  });
});

// On mobile: after tap release, unfocus the product card after 1s
document.addEventListener('touchstart', function (e) {
  const tile = e.target.closest('.product-tile');
  if (!tile) return;
  clearTimeout(tile._touchHoverTimer);
  tile.classList.remove('touch-unfocused');
}, { passive: true });

document.addEventListener('touchend', function (e) {
  const tile = e.target.closest('.product-tile');
  if (!tile) return;
  clearTimeout(tile._touchHoverTimer);
  tile._touchHoverTimer = setTimeout(function () {
    tile.classList.add('touch-unfocused');
  }, 1000);
}, { passive: true });

(function () {
  var SELECTORS = ['#reamazejs-container', 'body > .page', 'body > div.page'];

  function tagInjectedContainers() {
    SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        // Skip if it already has a role or is already inside a landmark.
        if (el.getAttribute('role')) return;
        if (el.parentElement && el.parentElement.closest('main, header, footer, nav, aside')) return;
        el.setAttribute('role', 'complementary');
        if (!el.getAttribute('aria-label')) el.setAttribute('aria-label', 'Additional content');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    tagInjectedContainers();
    // App embeds load late — re-check as they inject.
    var observer = new MutationObserver(function () {
      clearTimeout(observer._t);
      observer._t = setTimeout(tagInjectedContainers, 200);
    });
    observer.observe(document.body, { childList: true });
    setTimeout(function () { observer.disconnect(); }, 15000);
  });
})();
